import { createReducer, on } from '@ngrx/store';
import {
  LoadOrganizationReports,
  RemoveAnalyticsError,
  SetOrganizationReports,
  SetOrganizationReportsError,
} from './analytics.actions';
import { AnalyticsApiError } from './analytics.errors';
import { OrganizationReports } from 'src/app/admin/models/analytics.model';

export interface AnalyticsState {
  organizationReports: OrganizationReports;
  apiError: AnalyticsApiError;
}

export const initialState: AnalyticsState = {
  organizationReports: {},
  apiError: null,
};

export const analyticsReducer = createReducer(
  initialState,
  on(LoadOrganizationReports, (state) => ({ ...state, apiError: null })),
  on(SetOrganizationReports, (state, { organizationReports }) => ({
    ...state,
    apiError: null,
    organizationReports,
  })),
  on(SetOrganizationReportsError, (state, { error }) => ({ ...state, apiError: error })),
  on(RemoveAnalyticsError, (state) => ({ ...state, apiError: null })),
);
